import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

const STAFF_ROLES = ["super_admin", "admin", "manager", "user"];

const DEFAULT_PERMS = {
  dashboard: false, products_view: false, products_edit: false, products_delete: false,
  bookings_view: false, bookings_edit: false, enquiries_view: false, enquiries_edit: false,
  coupons_view: false, coupons_edit: false, blog_view: false, blog_edit: false,
  faq_edit: false, tickers_edit: false, pages_edit: false, banners_edit: false,
  settings: false, team_management: false, data_purge: false, approvals: false, categories_edit: false,
};

export function usePermissions() {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState(DEFAULT_PERMS);

  const isStaff = user && STAFF_ROLES.includes(user.role);
  const isAdmin = user && (user.role === "super_admin" || user.role === "admin");
  const isManager = user?.role === "manager";
  const isUser = user?.role === "user";

  useEffect(() => {
    if (!isStaff) { setPermissions(DEFAULT_PERMS); return; }
    api.get("/admin/permissions").then(r => setPermissions(r.data.permissions)).catch(() => {});
  }, [user?.id, user?.role, isStaff]);

  return { permissions, isStaff, isAdmin, isManager, isUser, role: user?.role };
}

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  manager: "Manager",
  user: "User",
  vendor: "Vendor",
  customer: "Customer",
};
